
import { Vue, Options, prop } from "vue-class-component";

class Props {
  intervalValue = prop<number>({
    default: 1,
    required: true,
    type: Number
  });
  daysValue = prop<string[]>({
    default: [],
    required: true,
    type: Array
  });
}

@Options({
  emits: ["setInterval", "setDays"]
})
export default class Repetable extends Vue.with(Props) {
  get optionWeeks() {
    return [
      {
        name: this.$t("pickupCorporate.weekOption", { count: 1 }),
        value: 1
      },
      {
        name: this.$t("pickupCorporate.weekOption", { count: 2 }),
        value: 2
      }
    ];
  }

  isMenu = false;
  showMenu() {
    this.isMenu = !this.isMenu;
  }

  selectWeek(value: number) {
    this.interval = value;
  }

  get days() {
    return [
      {
        name: this.$t("pickupCorporate.monday"),
        value: "monday",
        status: false
      },
      {
        name: this.$t("pickupCorporate.tuesday"),
        value: "tuesday",
        status: false
      },
      {
        name: this.$t("pickupCorporate.wednesday"),
        value: "wednesday",
        status: false
      },
      {
        name: this.$t("pickupCorporate.thursday"),
        value: "thursday",
        status: false
      },
      {
        name: this.$t("pickupCorporate.friday"),
        value: "friday",
        status: false
      },
      {
        name: this.$t("pickupCorporate.saturday"),
        value: "saturday",
        status: false
      },
      {
        name: this.$t("pickupCorporate.sunday"),
        value: "sunday",
        status: false
      }
    ];
  }

  get daysGetter() {
    return this.days.map(day => {
      return {
        ...day,
        status: this.daysValue.includes(day.value)
      };
    });
  }

  get interval() {
    return this.intervalValue
  }

  set interval(val) {
    this.$emit("setInterval", val);
  }

  setday(index: number) {
    const dayValue = this.days[index].value;

    let updatedDays = [...this.daysValue];

    if (updatedDays.includes(dayValue)) {
      updatedDays = updatedDays.filter(d => d !== dayValue);
    } else {
      updatedDays.push(dayValue);
    }

    this.$emit("setDays", updatedDays)
  }
}
